import { useMemo } from 'react';
import { useUser } from 'shared/hooks/use-user';
import { sortItems } from 'shared/utils/sort-items';

import { useLocalizedLifeAreas } from './use-localized-life-areas';

export const useSortedLocalizedLifeAreas = () => {
  const user = useUser();
  const lifeAreas = useLocalizedLifeAreas();

  return useMemo(
    () => sortItems(lifeAreas, user?.settings?.lifeAreaSorting ?? [], 'id'),
    [lifeAreas, user?.settings?.lifeAreaSorting],
  );
};
